interface SummaryItem {
  label: string;
  value: string;
  highlight?: boolean;
}

interface CalculatorSummaryProps {
  items: SummaryItem[];
}

export function CalculatorResultSummary({ items }: CalculatorSummaryProps) {
  return (
    <div className="grid grid-cols-3 gap-2 rounded-xl bg-card px-3 py-3 w-full">
      {items.map((item) => (
        <div
          key={item.label}
          className="flex flex-col col-span-1 items-center gap-0.5"
        >
          <span className="text-xs text-muted-foreground">{item.label}</span>
          <span
            className={
              item.highlight
                ? "text-base font-semibold text-constructive"
                : "text-base font-semibold text-foreground"
            }
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
}
